import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-landing-whats-new',
  templateUrl: './landing-whats-new.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-whats-new.component.scss']
})
export class LandingWhatsNewComponent implements OnInit {

  lightboxOpen = false;
  lightboxSrc = '';
  lightboxAlt = '';

  constructor(private router: Router, private title: Title, private meta: Meta, @Inject(DOCUMENT) private doc: Document) {}

  ngOnInit(): void {
    const CANON = 'https://geoastra.com';
    const url = `${CANON}/landing-whats-new`;
    this.title.setTitle("What's New in GeoAstra 2.0 — Features & Improvements");
    this.meta.updateTag({ name: 'description', content: 'Explore the latest features in GeoAstra NTRIP Caster 2.0: live connections monitor, data visualization, RTK Base Analyzer and PPK Downloader.' });
    this.meta.updateTag({ property: 'og:title', content: "What's New in GeoAstra 2.0" });
    this.meta.updateTag({ property: 'og:description', content: 'Live monitor, data visualization, RTK Base Analyzer, PPK Downloader.' });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: "What's New in GeoAstra 2.0" });
    this.meta.updateTag({ name: 'twitter:description', content: 'Latest features overview of GeoAstra NTRIP Caster 2.0.' });
    this.meta.updateTag({ name: 'twitter:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    let link: HTMLLinkElement | null = this.doc.querySelector("link[rel='canonical']");
    if (!link) { link = this.doc.createElement('link'); link.setAttribute('rel', 'canonical'); this.doc.head.appendChild(link); }
    link.setAttribute('href', url);
  }

  goBack(): void {
    this.router.navigate(['/landing-ntrip-caster']);
  }

  openLightbox(src: string, alt: string): void {
    this.lightboxSrc = src;
    this.lightboxAlt = alt || '';
    this.lightboxOpen = true;
  }

  closeLightbox(): void {
    this.lightboxOpen = false;
    this.lightboxSrc = '';
    this.lightboxAlt = '';
  }
}
